import http from 'conversations-http/clients/http';
import { registerQuery } from 'data-fetching-client';
export const USER_INFO_QUERY_NAME = 'userInfo';
export const USER_INFO_QUERY = registerQuery({
  fieldName: USER_INFO_QUERY_NAME,
  fetcher() {
    return http.get('login-verify/hub-user-info');
  }
});